import { List, Stack, Text, Title } from "@mantine/core"
import { InfoBox } from "@tfg/ui"

import type { FieldChangeDto, UpdatePreviewDto } from "~/gen/api"
import { formatValue } from "~/utils/formatting"

interface ProductBulkUpdateSummaryProps {
  readonly updatesPreview: readonly UpdatePreviewDto[]
}

export const ProductBulkUpdateSummary = ({
  updatesPreview,
}: ProductBulkUpdateSummaryProps) => {
  if (updatesPreview.length === 0) {
    return null
  }

  const productsList = (
    <List mah={300} style={{ overflowY: "auto" }}>
      {updatesPreview.map((update: UpdatePreviewDto, index: number) => (
        <List.Item key={`${update.productName}-${index}`}>
          <Title order={4} fz="sm">
            {update.originalData?.name}
          </Title>
          {update.changes.map((change: FieldChangeDto, index: number) => (
            <Stack key={`${change.field}-${index}`}>
              <Text component="span" fw={600}>
                {change.field}:{" "}
                <Text component="span" fw={400} fz="xs">
                  {formatValue(change.oldValue)}
                </Text>{" "}
                →{" "}
                <Text component="span" fw={400} fz="xs">
                  {formatValue(change.newValue)}
                </Text>
              </Text>
            </Stack>
          ))}
        </List.Item>
      ))}
    </List>
  )

  return (
    <InfoBox
      variant="info"
      title="Products to update"
      width="100%"
      message={productsList}
    />
  )
}
